import React from 'react'
import ReactMarkdown from 'react-markdown'
import { injectIntl, intlShape } from 'react-intl'

import './Events.css'

function groupByMonth(events) {
  events.shift();
  const groups = events.reduce(function (r, o) {
    var m = o.fields.date.split(('-'))[1];
    (r[m])? r[m].data.push(o) : r[m] = {month: m-1, events: [o]};
    return r;
  }, {});

  return Object.keys(groups).map(function(k){ return groups[k]; });
}

const Events = (props) => (
  <div>
    {props.title && <h2 className="events-title">{props.title}</h2>}
    <div className="events">
      <div className="container">
        {props.events && props.events.map((event, i) => {
          const dateParts = event.fields.date.split('-');
          const date = dateParts[2]+'.'+dateParts[1]+'.'+dateParts[0];

          if(i===0) {
          // if(event.fields.featured===true) {
            return(
              <div key={event.sys.id} className="featured">
                {event.fields.image && <div style={{backgroundImage: 'url('+event.fields.image.fields.file.url+'?fm=jpg&q=80)'}} />}
                <div>
                  <div>
                    <h4>Seuraavana vuorossa</h4>

                    <time dateTime={event.fields.date}>{date}</time>

                    <h3>{event.fields.title}</h3>

                    <ReactMarkdown source={event.fields.description} softBreak="br" />
                  </div>
                </div>
              </div>
            )
          }
          return null;
        })}
        {groupByMonth(props.events).map((month, i) => {
          const months = [
            'Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kesäkuu', 'Heinäkuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu'
          ]
          return(
            <div className="month" key={month.month}>
              <div>{months[month.month]}</div>
              <div>
                {month.events.map((event, i) => {
                  const dateParts = event.fields.date.split('-');
                  const date = dateParts[2]+'.'+dateParts[1]+'.'+dateParts[0];

                  return(
                    <div key={event.sys.id} className="event">
                      <time dateTime={event.fields.date}>{date}</time>

                      <h3>{event.fields.title}</h3>

                      <ReactMarkdown source={event.fields.description} softBreak="br" />
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  </div>
)

Events.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(Events)


// WEBPACK FOOTER //
// ./src/components/Events.js